import React from 'react';
import { InventoryItemList } from './StockManagement';

/**
 * Inventory Items Component
 *
 * Wrapper component that renders the InventoryItemList
 * for managing raw materials and ingredients.
 */

export default function InventoryItems() {
  return <InventoryItemList />;
}
